var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('image-view',{attrs:{"image":_vm.song.image}},[_c('h1',[_vm._v(_vm._s(_vm.song.title))]),_c('h4',{staticClass:"text-secondary"},[_vm._v(_vm._s(_vm.song.album))]),_c('p',[_vm._v(_vm._s(_vm.song.description))])])}
var staticRenderFns = []

export { render, staticRenderFns }